import React from "react";
import { Card, CardContent, CardMedia, Typography, Button, Stack, Box, Chip } from "@mui/material";

// ---------------- card style ----------
const cardStyle = {
  borderRadius: 2, marginBottom: 1 , backgroundColor:'#FFFFFF'
}
const typographyStyle = {
   fontWeight: "bold", fontSize: '18px', color: '#626478'
}
const ReusableCardView = ({ title, Component , disablepaddingBottom = false , padding, required = false}) => {
  return (
    <Box sx={cardStyle}>
      <CardContent sx={{ padding: '0px 0px' , paddingBottom: disablepaddingBottom ?'0px !important' : '0px !important' }} >
        {/* About the Event Header */}
        <Typography variant="h6" padding={padding !== undefined ? padding : "16px 16px 0px 16px"} sx={typographyStyle}>
          {title}
          {required ? <span style={{ color: '#d32f2f' }}> *</span> : null}
        </Typography>

        {Component}

        
      </CardContent>
    </Box>
  );
};

export default ReusableCardView;
